module.exports = __webpack_public_path__ + "img/ico-instagram.8eaf9e77.svg";